import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>Developed by Sreeja Raj</p>
      <p>Contact: isreejaraj@gmail.com</p>
    </footer>
  );
}

export default Footer;